export default __webpack_public_path__ + "static/media/(13).cbadc9b8.jpeg";